"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from "react";
import { useTranslations } from "next-intl";
import { Dialog, DialogContent, DialogTitle, DialogHeader, DialogFooter } from "@repo/ui/dialog";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@repo/ui/accordion";
import { Button } from "@repo/ui/button";
import { Checkbox } from "@repo/ui/checkbox";
import { DateRangePicker } from "@repo/ui/date-range-picker";
import type { CategoryOption, FilterGroup } from "./directory-listing.types";
interface DirectoryFilterDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  categoryOptions: CategoryOption[];
  filterGroups: FilterGroup[];
  selectedCategories: Set<string>;
  selectedFilters: Record<string, Set<string>>;
  onApply: (filters: Record<string, Set<string>>, dateRange?: {
    from: string | null;
    to: string | null;
  }) => void;
  onClear: () => void;
  hasDateFilter?: boolean;
  dateFrom: string | null;
  dateTo: string | null;
}
export function DirectoryFilterDialog(t0) {
  const $ = _c(76);
  const {
    open,
    onOpenChange,
    categoryOptions,
    filterGroups,
    selectedCategories,
    selectedFilters,
    onApply,
    onClear,
    hasDateFilter: t1,
    dateFrom,
    dateTo
  } = t0;
  const hasDateFilter = t1 === undefined ? false : t1;
  const t = useTranslations("directory");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [staged, setStaged] = useState(t2);
  const [stagedDateFrom, setStagedDateFrom] = useState(null);
  const [stagedDateTo, setStagedDateTo] = useState(null);
  const [wasOpen, setWasOpen] = useState(false);
  if (open !== wasOpen) {
    setWasOpen(open);
    if (open) {
      const initial = {
        category: new Set(selectedCategories)
      };
      for (const group of filterGroups) {
        initial[group.key] = new Set(selectedFilters[group.key] ?? []);
      }
      setStaged(initial);
      setStagedDateFrom(dateFrom);
      setStagedDateTo(dateTo);
    }
  }
  let t3;
  if ($[1] !== onOpenChange) {
    t3 = nextOpen => onOpenChange(nextOpen);
    $[1] = onOpenChange;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleOpenChange = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (groupKey, id) => {
      setStaged(prev => {
        const groupSet = new Set(prev[groupKey] ?? []);
        if (groupSet.has(id)) {
          groupSet.delete(id);
        } else {
          groupSet.add(id);
        }
        return {
          ...prev,
          [groupKey]: groupSet
        };
      });
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const toggleStaged = t4;
  let t5;
  if ($[4] !== handleOpenChange || $[5] !== onApply || $[6] !== staged || $[7] !== stagedDateFrom || $[8] !== stagedDateTo) {
    t5 = () => {
      onApply(staged, {
        from: stagedDateFrom,
        to: stagedDateTo
      });
      handleOpenChange(false);
    };
    $[4] = handleOpenChange;
    $[5] = onApply;
    $[6] = staged;
    $[7] = stagedDateFrom;
    $[8] = stagedDateTo;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleApply = t5;
  let t6;
  if ($[10] !== handleOpenChange || $[11] !== onClear) {
    t6 = () => {
      onClear();
      handleOpenChange(false);
    };
    $[10] = handleOpenChange;
    $[11] = onClear;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleClear = t6;
  let T0;
  let T1;
  let T2;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t7;
  let t8;
  let t9;
  if ($[13] !== categoryOptions || $[14] !== filterGroups || $[15] !== handleOpenChange || $[16] !== hasDateFilter || $[17] !== open || $[18] !== staged || $[19] !== stagedDateFrom || $[20] !== stagedDateTo || $[21] !== t) {
    const allSections = [...(categoryOptions.length > 0 ? [{
      key: "category",
      label: t("categories"),
      options: categoryOptions
    }] : []), ...filterGroups.filter(_temp)];
    T2 = Dialog;
    t14 = open;
    t15 = handleOpenChange;
    T1 = DialogContent;
    t12 = "desktop:max-w-[513px]";
    let t16;
    if ($[34] !== t) {
      t16 = t("filter");
      $[34] = t;
      $[35] = t16;
    } else {
      t16 = $[35];
    }
    if ($[36] !== t16) {
      t13 = <DialogHeader><DialogTitle>{t16}</DialogTitle></DialogHeader>;
      $[36] = t16;
      $[37] = t13;
    } else {
      t13 = $[37];
    }
    t11 = "flex-1 overflow-y-auto p-6";
    T0 = Accordion;
    t7 = "multiple";
    t8 = [...allSections.map(_temp2), ...(hasDateFilter ? ["dateRange"] : [])];
    if ($[38] !== hasDateFilter || $[39] !== stagedDateFrom || $[40] !== stagedDateTo || $[41] !== t) {
      t9 = hasDateFilter && <AccordionItem value="dateRange" className="border-none"><AccordionTrigger>{t("dateRange")}</AccordionTrigger><AccordionContent><div className="pt-2"><DateRangePicker dateFrom={stagedDateFrom} dateTo={stagedDateTo} onChange={(from, to) => {
              setStagedDateFrom(from);
              setStagedDateTo(to);
            }} startDateLabel={t("startDate")} endDateLabel={t("endDate")} /></div></AccordionContent></AccordionItem>;
      $[38] = hasDateFilter;
      $[39] = stagedDateFrom;
      $[40] = stagedDateTo;
      $[41] = t;
      $[42] = t9;
    } else {
      t9 = $[42];
    }
    t10 = allSections.map(section => <AccordionItem key={section.key} value={section.key} className="first:border-t-0"><AccordionTrigger>{section.label}</AccordionTrigger><AccordionContent><div className="flex flex-col gap-3">{section.options.map(option => <Checkbox key={option._id} size="sm" label={option.name ?? ""} checked={staged[section.key]?.has(option._id) ?? false} onChange={() => toggleStaged(section.key, option._id)} />)}</div></AccordionContent></AccordionItem>);
    $[13] = categoryOptions;
    $[14] = filterGroups;
    $[15] = handleOpenChange;
    $[16] = hasDateFilter;
    $[17] = open;
    $[18] = staged;
    $[19] = stagedDateFrom;
    $[20] = stagedDateTo;
    $[21] = t;
    $[22] = T0;
    $[23] = T1;
    $[24] = T2;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
  } else {
    T0 = $[22];
    T1 = $[23];
    T2 = $[24];
    t10 = $[25];
    t11 = $[26];
    t12 = $[27];
    t13 = $[28];
    t14 = $[29];
    t15 = $[30];
    t7 = $[31];
    t8 = $[32];
    t9 = $[33];
  }
  let t16;
  if ($[43] !== T0 || $[44] !== t10 || $[45] !== t7 || $[46] !== t8 || $[47] !== t9) {
    t16 = <T0 type={t7} defaultValue={t8}>{t9}{t10}</T0>;
    $[43] = T0;
    $[44] = t10;
    $[45] = t7;
    $[46] = t8;
    $[47] = t9;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  let t17;
  if ($[49] !== t11 || $[50] !== t16) {
    t17 = <div className={t11}>{t16}</div>;
    $[49] = t11;
    $[50] = t16;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] !== t) {
    t18 = t("applyFilters");
    $[52] = t;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  let t19;
  if ($[54] !== handleApply || $[55] !== t18) {
    t19 = <Button onClick={handleApply}>{t18}</Button>;
    $[54] = handleApply;
    $[55] = t18;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  let t20;
  if ($[57] !== t) {
    t20 = t("clearAll");
    $[57] = t;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  let t21;
  if ($[59] !== handleClear || $[60] !== t20) {
    t21 = <Button variant="blue-outline" onClick={handleClear}>{t20}</Button>;
    $[59] = handleClear;
    $[60] = t20;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== t19 || $[63] !== t21) {
    t22 = <DialogFooter>{t19}{t21}</DialogFooter>;
    $[62] = t19;
    $[63] = t21;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  let t23;
  if ($[65] !== T1 || $[66] !== t12 || $[67] !== t13 || $[68] !== t17 || $[69] !== t22) {
    t23 = <T1 className={t12}>{t13}{t17}{t22}</T1>;
    $[65] = T1;
    $[66] = t12;
    $[67] = t13;
    $[68] = t17;
    $[69] = t22;
    $[70] = t23;
  } else {
    t23 = $[70];
  }
  let t24;
  if ($[71] !== T2 || $[72] !== t14 || $[73] !== t15 || $[74] !== t23) {
    t24 = <T2 open={t14} onOpenChange={t15}>{t23}</T2>;
    $[71] = T2;
    $[72] = t14;
    $[73] = t15;
    $[74] = t23;
    $[75] = t24;
  } else {
    t24 = $[75];
  }
  return t24;
}
function _temp2(s) {
  return s.key;
}
function _temp(g) {
  return g.options.length > 0;
}